import * as React from "react";
import {
  Box,
  Drawer,
  IconButton,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import images from "assets/images/images";
import { colors } from "styles/colors";
import { useHistory, useLocation } from "react-router-dom";
import LogoutModal from "./LogoutModal";
import { getStudentNavbarSelected } from "utils/helpers";
import { useQuery } from "@apollo/client";
import { GET_ASSESSMENT_PURCHASE_STATUS } from "app/graphql/StudentMESSection";

const StudentMobileNavigationDrawer = (props) => {
  const { mobileOpen, setMobileOpen } = props;

  const location = useLocation();
  const [assessmentPurchased, setAssessmentPurchased] = React.useState(false);
  
  const { data: purchaseStatusData } = useQuery(GET_ASSESSMENT_PURCHASE_STATUS, {
    onCompleted: (data) => {
      const { get_assessment_bundle_purchase_status } = data;
      const { status, is_assessment_bundle_purchased } =
        get_assessment_bundle_purchase_status;
      if (status && is_assessment_bundle_purchased) {
        setAssessmentPurchased(true);
      }
    },
    nextFetchPolicy: "network-only",
    fetchPolicy: "network-only"
  });

  const navItems = [
    {
      id: 0,
      title: "Dashboard",
      path: "/student-dashboard",
      image1: images.home_icon_blue,
      image2: images.home_icon_grey
    },
    {
      id: 1,
      title: "Jobs / Campus Drives",
      path: "/student/job-campus-drives",
      image1: images.suitcase_icon_blue,
      image2: images.suitcase_icon_grey
    },
    {
      id: 2,
      title: "Upskilling",
      path: "/student-upskilling",
      image1: images.upskilling_icon_blue,
      image2: images.upskilling_icon_grey
    },
    ...(assessmentPurchased
      ? [
          {
            id: 3,
            title: "Ma Foi Score",
            path: "/student-mafoi-employability-score",
            image1: images.score_icon_blue,
            image2: images.score_icon_grey
          }
        ]
      : []),
    // {
    //   id: 4,
    //   name: "Events",
    //   path: "/student-events",
    //   image1: images.date_icon_blue,
    //   image2: images.date_icon_grey
    // },
    // {
    //   id: 4,
    //   name: "My Application",
    //   path: "/student-myapplication",
    //   image1: images.application_icon_blue,
    //   image2: images.application_icon_grey,
    // },
    {
      id: 5,
      title: "Self Care",
      path: "/student-selfcare",
      image1: images.date_icon_blue,
      image2: images.date_icon_grey
    },
    {
      id: 6,
      title: "Profile",
      path: "/student-profile",
      image1: images.profile_icon_blue,
      image2: images.profile_icon_grey
    },
    // {
    //   id: 7,
    //   title: "Resume Builder",
    //   path: "/student-resume-templates",
    //   image1: images.resume_builder_icon_blue,
    //   image2: images.resume_builder_icon_grey
    // },
    // {
    //   id: 8,
    //   title: "Notification",
    //   path: "/student-notifications",
    //   image1: images.notification_icon_blue,
    //   image2: images.notification_icon_grey
    // }
  ];

  const history = useHistory();
  const handleDrawerToggle = () => {
    setMobileOpen(false);
  };

  const [logoutModal, setLogoutModal] = React.useState(false);

  const drawer = (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
      <Box>
        <Box
          sx={{
            width: "100%",
            px: 2,
            py: 0.75,
            display: "flex",
            borderBottom: `1px solid ${colors.lightGreyBorder}`,
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)"
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexGrow: 1
            }}
          >
            <img src={images.prosculpt_logo_colored} style={{ width: "120px" }} />
          </Box>
          <IconButton color="primary" edge="start" onClick={handleDrawerToggle} aria-label="Close">
            <CloseIcon fontSize="large" />
          </IconButton>
        </Box>
        <List>
          {navItems?.map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                sx={{ display: "flex", alignItems: "center" }}
                onClick={() => history.push(`${item.path}`)}
                aria-label={`Navigate to ${item.title}`}
              >
                <img
                  src={
                    getStudentNavbarSelected(location, item)
                      ? item.image1
                      : item.image2
                  }
                  height={20}
                  alt="My SVG"
                />
                <ListItemText
                  sx={{
                    fontWeight: 600,
                    letterSpacing: "0.5px",
                    display: "flex",
                    alignItems: "baseline",
                    ml: 1,
                    mt: 1,
                    color: getStudentNavbarSelected(location, item)
                      ? colors.primaryBlue
                      : colors.fontGrey
                  }}
                  primary={item.title}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
      <Box sx={{ px: 2.5, mb: 4 }}>
        <Box sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            sx={{
              width: "100%",
              mx: "auto",
              py: 1.25,
              borderRadius: 0
            }}
            onClick={() => {
              setLogoutModal(true);
            }}
            aria-label="Logout"
          >
            Logout
          </Button>
        </Box>
        <LogoutModal
          open={logoutModal}
          setOpen={setLogoutModal}
          width={"340px"}
        />
      </Box>
    </Box>
  );

  return (
    <Drawer
      variant="temporary"
      open={mobileOpen}
      onClose={handleDrawerToggle}
      ModalProps={{
        keepMounted: true
      }}
      sx={{
        display: { xs: "block", sm: "block", md: "none" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: "100%"
        }
      }}
    >
      {drawer}
    </Drawer>
  );
};

export default StudentMobileNavigationDrawer;
